'use strict';

angular.module('TurneroApp').service('signalrDotNetCoreService', [
    '$q',
    'TurneroAppConstant',
    '$rootScope',
    function ($q, TurneroAppConstant, $rootScope) {
        var self = this;
        var Url = $rootScope.urlHostServer + "signalr/"; //URL_del_sitio/signalr
        var hubs = { LlamadorHub: null, PuestosHub: null, TurnosHub: null };
        var timeoutIds = { LlamadorHub: 0, PuestosHub: 0, TurnosHub: 0 };
        //var reconnectionWaitTimes = { LlamadorHub: 0, PuestosHub: 0, TurnosHub: 0 };
        var reconnectionDelays = { LlamadorHub: 0, PuestosHub: 0, TurnosHub: 0 };

        this.getHub = function (hubName) {
            return $q(function (resolve) {
                if (hubName && !hubs[hubName]) {
                    hubs[hubName] = new signalR.HubConnectionBuilder()
                        //signalR.HttpTransportType.ServerSentEvents | <-Falta ensayar y que funcione
                        .withUrl(Url + hubName,
                            {
                                //skipNegotiation: true, <-Sólo apto para WebSockets
                                transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.LongPolling
                            })  //Ver que pueda trabajar también con ServerSentEvents ya que la versión Core de SignalR NO tiene fallback de tranport type/protocolos si hay problemas/incompatibilidades en la comunicación/server
                        .withAutomaticReconnect([0, 1000, 5000])
                        //.withHubProtocol(new signalR.protocols.msgpack.MessagePackHubProtocol())
                        .configureLogging(signalR.LogLevel.Debug)
                        .build();
                    hubs[hubName].onclose(function (error) { self.oncloseHub(hubName, error); });
                }
                resolve(hubs[hubName]);
            });
        };

        this.startHub = function (hubName) {
            return this.getHub(hubName).then(function (hubConnection) {
                if (hubConnection.connectionState == signalR.HubConnectionState.Disconnected) {
                    $rootScope.$broadcast('BeforeHubConnectionStart', hubConnection);
                    console.info("SignalR connection " + hubName + " iniciándose...");
                    return hubConnection.start().then(function () {
                        resetReconnection(hubName); //Una vez conectado, la próxima eventual desconexión se debe reconectar con CERO delay
                        console.info("SignalR connection " + hubName + " iniciada.");
                        $rootScope.$broadcast('AfterHubConnectionStart', hubConnection);
                        return hubConnection;
                    }).catch(function (err) {
                        console.error("SignalR connection " + hubName + " falló el inicio: " + err.toString());
                        if (hubs[hubName].connectionState == signalR.HubConnectionState.Disconnected) {
                            console.error("SignalR connection " + hubName + " se reintentará el inicio...");
                            clearTimeout(timeoutIds[hubName]);
                            timeoutIds[hubName] = setTimeout(() => self.startHub(hubName), getReconnectionWaitTime(hubName)); //Esto a futuro tiene que ser quizá con límite
                        }
                        throw err;
                    });
                } else {
                    return hubConnection;
                }
            });
        };

        self.oncloseHub = function (hubName, error) {
            if (hubs[hubName]) {
                $rootScope.$broadcast('AfterHubConnectionClose', hubs[hubName]);
                if (!error || error.stack.toLowerCase().indexOf('eventsource') === -1) {
                    console.warn("SignalR connection " + hubName + " desconectada.");
                    clearTimeout(timeoutIds[hubName]);
                    timeoutIds[hubName] = setTimeout(() => self.startHub(hubName), getReconnectionWaitTime(hubName)); //Esto a futuro tiene que ser quizá con límite
                } else {
                    console.warn("SignalR connection " + hubName + " ServerSentEvents desconectada antes de notificar excepción.");
                }
            }
        };


        this.stopHub = function (hubName) {
            if (hubs[hubName]) {
                var hubConnection = hubs[hubName];
                if (hubConnection.connectionState == signalR.HubConnectionState.Connected) {
                    console.info("SignalR connection " + hubName + " deteniéndose...");
                    hubs[hubName] = null;
                    hubConnection.stop().then(function () {
                        console.info("SignalR connection " + hubName + " detenida.");
                    }).catch(function (err) {
                        console.error("SignalR connection " + hubName + " falló la detención: " + err.toString());
                        //throw err;
                    });
                } else {
                    console.warn("SignalR connection " + hubName + " ya estaba detenida.");
                }
            }
        };

        function resetReconnection(hubName) {
            reconnectionDelays[hubName] = 0;
            //reconnectionWaitTimes[hubName] = getRandomInteger(0, 1000);
        }

        function getReconnectionWaitTime(hubName) {
            var spacingTime = getRandomInteger(0, 1000);
            var waitTime = reconnectionDelays[hubName] + spacingTime;
            if (reconnectionDelays[hubName] < 30000) reconnectionDelays[hubName] = reconnectionDelays[hubName] + 1000;
            console.info("SignalR connection " + hubName + " reintentará en " + waitTime + "ms.");
            return waitTime;
        }

        function getRandomInteger(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }
    }]);


// WEBPACK FOOTER //
// ./app/components/general/signalrDotNetCoreService.js